import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Header, Footer } from '@hydra/common/components';
import LayoutShell from '@hydra/common/shell/LayoutShell';
import { Shell } from '@hydra/types/shell';

interface HeaderFooterShellProps extends Shell {
  HeaderProps?: object
  FooterProps?: object
}

export default function HeaderFooterShell ({
  className,
  children,
  hideFooter = false,
  hideHeader = false,
  bgColor: bgColorProp,
  HeaderProps = {},
  FooterProps = {}
}: HeaderFooterShellProps) {
  const theme = useTheme();
  const bgColor = bgColorProp || theme.palette.background.default;

  return (
    <>
      {!hideHeader && <Header {...HeaderProps} />}
      <LayoutShell sideNav={false} bgColor={bgColor} className={className}>
        {children}
      </LayoutShell>
      {!hideFooter && <Footer bgColor={bgColor} {...FooterProps} />}
    </>
  );
}
